// extracted by mini-css-extract-plugin
module.exports = {"paper":"ApxViewReport_paper__3mkGC","logo":"ApxViewReport_logo__3WH9k"};